<template>
  <div class="authentication">
    <div class="authentication-content">
      <div class="step">
        <a-row>
          <a-col :span="8" :offset="1">
            <a-steps
              :current="currentProcess"
              type="navigation"
              @change="changeStep"
            >
              <a-step
                title="提交作品"
                description=""
              >
                <div slot="icon" slot-scope="{ status }">
                  <div :class="{'step_1': status === 'wait','step_1_active': status === 'process', 'step_done': status ==='finish'}"></div>
                </div>
              </a-step>
              <a-step title="实名认证" description="" >
                <div slot="icon" slot-scope="{ status }">
                  <div :class="{'step_2_active': status === 'process', 'step_done': status ==='finish'}"></div>
                </div>
              </a-step>

            </a-steps>
          </a-col>
        </a-row>

      </div>
      <div class="realName" v-show="currentProcess === 1">
        <a-row>
          <a-col :offset="1">
            <a-form :form="form">
              <a-form-item>
                <a-input style="width:328px;height: 40px" v-decorator="['username',{rules: [{required:true, message: '*请输入姓名'}]}]" placeholder="姓名">
                  <span slot="prefix" class="user-icon"></span>
                </a-input>
              </a-form-item>
              <a-form-item>
                <a-input
                  style="width:328px;height: 40px"
                  v-decorator="['id_card',{
                    rules: [{required:true, message: '*请输入身份证号'},{ validator:checkIdCard }],
                    validateTrigger: ['blur']
                  }]"
                  placeholder="身份证号">
                  <span slot="prefix" class="idNum-icon"></span>
                </a-input>
              </a-form-item>
              <p style="margin-bottom:15px"><span class="primary">*</span> 上传身份证正反面</p>
              <a-row class="upload-box" type="flex" align="middle">

                <div class="upload-wrap" style="margin-right:20px">
                  <upload-image
                    :bucketType="'3'"
                    @onSuccess="onSuccessFront"

                    :clip="true"
                    :clipOption="{
                      autoCropWidth:430,
                      autoCropHeight:269,
                      fixedNumber: [430, 269]
                    }"
                    :data="idCard.front"
                    :path="idCardPath"
                    :bgImg="require('../../assets/img/img_id_card_z_200_125@2x.png')"></upload-image>
                </div>

                <div class="upload-wrap" style="margin-right:16px">
                  <upload-image
                    :bucketType="'3'"
                    @onSuccess="onSuccessBack"

                    :clip="true"
                    :clipOption="{
                      autoCropWidth:430,
                      autoCropHeight:269,
                      fixedNumber: [430, 269]
                    }"

                    :data="idCard.back"
                    :path="idCardPath"
                    :bgImg="require('../../assets/img/img_id_card_f_200_125@2x.png')"></upload-image>
                </div>
                <span class="error-tips" v-if="errTips.length > 0">{{ errTips }}</span>

              </a-row>
              <div class="btn-list">
                <a-button @click="goPrev" style="width: 100px; height: 40px; margin-right:20px">上一步</a-button>
                <a-button @click="submit" style="width: 100px;height: 40px; " type="primary">提交</a-button>
              </div>
            </a-form>
          </a-col>
        </a-row>
      </div>
      <div class="work-upload" v-show="currentProcess === 0">
        <a-row>
          <a-col :offset="1">
            <div class="notice">
              <span class="primary">*</span>  注意看小贴士哦！<br>
              1、需上传 5 套作品，每套作品包括<span class="primary">作品和对应线稿</span>，上传完当前一套后方可上传下一套。<br>
              2、单个上传作品大小控制在 2MB 之内，格式PNG、JPG或JPEG均可。
            </div>
            <div class="work-list">
              <div class="work-item" v-for="(item,index) in sample" :key="index">
                <div class="title">
                  第 {{ index + 1 }} 套作品:
                </div>
                <div class="content">
                  <div class="work">
                    <upload-image

                      @onSuccess="checkImg"
                      :data="item.opus"
                      :path="workPath"
                      :limit="2048"
                      :bgImg="require('../../assets/img/img_upload_work_120@2x.png')"
                    ></upload-image>

                  </div>
                  <div class="work">
                    <upload-image

                      @onSuccess="checkImg"
                      :limit="2048"
                      :data="item.sketch"
                      :path="workPath"
                      :bgImg="require('../../assets/img/img_upload_draft_120@2x.png')"></upload-image>

                  </div>
                </div>
              </div>
            </div>
            <div class="sample">
              <div class="title">
                样例图：
              </div>
              <div class="sample-list">
                <div class="sample-item">
                  <img src="../../assets/img/img_example_work_120@2x.png" alt="">
                </div>
                <div class="sample-item">
                  <img src="../../assets/img/img_example_draft_120@2x.png" alt="">
                </div>
              </div>
            </div>
            <a-button type="primary" @click="next()">
              下一步
            </a-button>

          </a-col>
        </a-row>
      </div>
    </div>

  </div>
</template>

<script>
import { getRandom } from '@/utils/util.js'
import { mapActions } from 'vuex'
import uploadImage from '@/components/Zpace/UploadImage/UploadImage'
export default {
  name: 'UserAuthentication',
  components: {
    uploadImage
  },
  data () {
    return {
      workPath: 'resources/cloud/work_web/',
      idCardPath: 'resources/cloud/idCard_web/',
      currentProcess: 0,
      form: this.$form.createForm(this),
      errTips: '',

      idCard: {
        front: {
          image: '',
          loading: false,
          percent: '0'
        },
        back: {
          image: '',
          loading: false,
          percent: '0'
        }
      },
      sample: [
        {
          opus: {
            loading: false,
            percent: '0',
            image: '',
            error: ''
          },
          sketch: {
            loading: false,
            percent: '0',
            image: '',
            error: ''
          }

        }
      ],
      uploadIndex: 0
    }
  },
  computed: {
  },
  created () {
    this.burry('8')
  },
  methods: {
    ...mapActions(['getQiniuToken']),
    goHomeHandle () {
      this.$router.push({ name: 'login' })
    },
    onSuccessFront () {
      this.errTips = ''
    },
    onSuccessBack () {
      this.errTips = ''
    },
    changeStep (e) {
      if (this.currentProcess == 0 && this.sample.length < 5) {
        this.$message.error('需提交5组作品！')
        return
      }
      this.currentProcess = e
    },
    next () {
      if (this.sample.length < 5) {
        this.burry('10')
        this.$message.error('需提交5组作品！')
        return
      }
      this.currentProcess += 1
      this.burry('9')
      this.burry('11')
    },
    name () {
      return getRandom(4) + Math.floor(new Date().getTime() / 1000) + getRandom(4)
    },
    checkImg () {
      if (this.sample[this.uploadIndex].opus.image !== '' && this.sample[this.uploadIndex].sketch.image !== '' && this.uploadIndex < 4) {
        this.uploadIndex += 1
        this.sample.push({
          opus: {
            loading: false,
            percent: '0%',
            image: ''
          },
          sketch: {
            loading: false,
            percent: '0%',
            image: ''
          }
        })
      }
    },
    submit () {
      this.form.validateFields((err, values) => {
        if (!this.idCard.front.image && !this.idCard.back.image) {
          this.burry('13')
          this.errTips = '*请填充身份证正反面'
          return
        } else if (!this.idCard.back.image) {
          this.burry('13')
          this.errTips = '*请填充身份证反面'
          return
        } else if (!this.idCard.front.image) {
          this.burry('13')
          this.errTips = '*请填充身份证正面'
          return
        }
        if (err) {
          this.burry('13')
          return
        }
        const params = {}
        params.username = this.form.getFieldValue('username')
        params.id_card = this.form.getFieldValue('id_card')
        params.id_card_front = this.idCard.front.image
        params.id_card_back = this.idCard.back.image
        const arr = []
        this.sample.map(item => {
          arr.push({
            opus: item.opus.image,
            sketch: item.sketch.image
          })
        })
        params.sample = JSON.stringify(arr)
        this.$api.user.authentication(params).then(res => {
          if (res.status === 'ok') {
            this.burry('12')
            const userInfo = this.$store.state.user.info
            console.log(userInfo)
            userInfo.authentication_status = 1 // 用户认证状态 @0:未认证 @1:认证中 @2：认证成功 @3:认证失败
            this.$router.push({
              path: '/manage/chartlet'
            })
          }
          // else {
          //   this.$router.push({
          //     path: '/manage/account',
          //     query: res.status
          //   }),
          //   this.$router.push({
          //     path: '/mange/assets',
          //     query: res.data
          //   })
          // }
        })
      })
    },
    goPrev () {
      this.currentProcess -= 1
    },
    checkIdCard (rule, value, callback) {
      console.log(rule, value)
      if (value && value.length !== 18) {
        callback(new Error('身份证号格式错误'))
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="less" scoped>
*{
    touch-action: pan-y;
    touch-action: none;
}

img {
  display: inline-block;
  width: 100%;
  height: auto;
}
.authentication{
  background-color: #EFF1F5;
  .authentication-content {
    background-color: #fff;
    padding-bottom: 200px;
    margin: 0 auto;
  }
  /deep/
  .ant-btn {
    width: 100px;
   height: 40px;
   border-radius: 8px;
  }
  .step {
    border:1px solid #F2F2F2;
    /deep/
    .ant-steps-navigation .ant-steps-item-container {
      padding-bottom: 22px;
      padding-top: 22px;
      width: 100%;
      margin-left: 0;
    }
    /deep/
    .ant-steps-item-icon {
      margin-right: 12px;
    }
    /deep/
    .ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item{
      margin-right: 156px;
    }
    /deep/
    .ant-steps-navigation .ant-steps-item::after {
      margin-top: -8px ;
      width: 116px;
      height: 6px;
      left: initial;
      right: -192px;
      background-image: url('../../assets/img/img_line_116_6@2x.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      transform: none;
      border: none;
      transform: translateX(-50%);

    }
  }
  /deep/
  .ant-form-item-with-help {
    margin-bottom: 24px;
  }
  /deep/
  .ant-form-item-control {
    display: flex;
    align-items: center;
    .ant-form-explain {
      margin-left: 16px;
    }
  }
  .realName {
    margin-top: 40px;
    .error-tips {
      color: #F51B27;
    }
    .upload-wrap {
        width: 200px;
        height: 126px;
      }
    .upload-box{
      margin-bottom: 40px;

    }

  }
  .work-upload{
    padding: 40px 0;
    .notice{
      color: #999999;
      font-size: 14px;
      margin-bottom: 30px;
    }
    .work-list {
      .work-item {
        margin-bottom: 30px;
        .title {
          font-size: 14px;
          font-weight: bold;
          color: #999999;
          margin-bottom: 16px;
        }
        .content {
          display: flex;
          .work {
            width: 120px;
            height: 120px;
            margin-right: 20px;
          }
        }
      }
    }
    .sample {
      margin-bottom: 40px;
      .title {
         font-size: 14px;
          font-weight: bold;
          color: #999999;
          margin-bottom: 16px;
      }
      .sample-list {
        display: flex;

        .sample-item {
          width: 120px;
          height: 120px;
          margin-right: 20px;
          img {
            display: block;
            width: 100%;
            height: auto;
          }
        }
      }
    }

  }
}
</style>
